export default "__VITE_ASSET__9vW8YUd0__"